import {
    useSearchParams,
} from 'react-router-dom';

import React, { useRef } from 'react';

import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import getDay from 'date-fns/getDay'
import enUS from 'date-fns/locale/en-US'

import 'react-big-calendar/lib/css/react-big-calendar.css';
//import 'react-big-calendar/lib/sass/styles.scss';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';

import EditEventDialog from 'components/Dialogs/EditEventDialog';
import EventDialog from 'components/Dialogs/EventDialog';

import {
    Avatar,
    Box,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    MenuItem,
    IconButton,
    Tooltip,
    TextField,
    Autocomplete,
    Snackbar
} from '@mui/material';

import { emails } from '../../data/data';

import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { EditRounded, DeleteRounded, SaveAltRounded, CancelRounded } from '@mui/icons-material';

import { useSelector, useDispatch } from 'react-redux';
import { setCalendarDate, setCalendarView } from 'state/reducers/authReducer';
import { useCallback, useEffect, useState } from 'react';

import { fetchEvents, deleteEvent, createOrUpdateEvent } from 'api/calendar';

import { isSameDay } from 'date-fns';
import { third_party_constants } from 'constants/third_party_constants';
import { useLoaderData } from 'react-router-dom';

// Calendar setup
const locales = { 'en-US': enUS };
const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales
});
const DnDCalendar = withDragAndDrop(Calendar);

//https://github.com/jquense/react-big-calendar/issues/191#issuecomment-1131174408
//TODO: Allow users to add shortcuts to special days
// https://next.mui.com/x/react-date-pickers/shortcuts/
const CalendarPage = ({}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    
    // Calendar state
    const date = useSelector((state) => state.auth.calendar.date);
    const view = useSelector((state) => state.auth.calendar.view);
    const currentWorkspaces = useSelector((state) => state.auth.user?.currentWorkspaces);
    const allWorkspaces = useSelector(state => state.auth.user?.allWorkspaces);
    const token = useSelector((state) => state.auth.token);

    const dispatch = useDispatch();
    
    const [eventsList, setEventsList] = useState([]);
    
    // Fetch events from Calendar API
    useEffect(() => {
        const getAllEvents = async () => {
            const { events, missingScopes } = await fetchEvents(token, { includeAllDay: true });
            setEventsList(events);

            console.log(events)
        };
        getAllEvents();
    }, [currentWorkspaces]);

    useEffect(() => {
        const email = searchParams.get("email");
        const displayName = searchParams.get("displayName");

        if (email && displayName) handleSelectSlots(null, { attendees: [{email, displayName}] });

    }, [searchParams.get("email"), searchParams.get("displayName")]);

    /**
     * assigning a color for each event based on the workspaceId of the event
     */
    // get all unique workspaceIds in eventsList
    const workspaceIds = [...new Set(eventsList?.map((event) => event.workspaceId))];
    // assign a color to each workspaceId
    const workspaceColors = workspaceIds?.map((id, index) => {
        const colors = ["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#9e9e9e", "#607d8b"];
        return { id, color: colors[index] };
    });

    const eventStyleGetter = (event) => {
        const color = workspaceColors.find((workspace) => workspace.id === event.workspaceId)?.color;
        const style = {
            backgroundColor: color
        };
        return {
            style: style
        };
    };

    // move or resize event
    // TODO: snackbar
    const moveEvent = useCallback(async ({ event, start, end }) => {
        const { allDay } = event;
        
        setEventsList((prev) => {
            const existing = prev.find((ev) => ev.id === event.id) ?? {};
            const filtered = prev?.filter((ev) => ev.id !== event.id);
            return [...filtered, { ...existing, start, end, allDay }];
        });

        // values to patch
        const values = {
            eventId: event.id,
            prevWorkspaceId: event.workspaceId,
            workspaceId: event.workspaceId,
            startDate: new Date(start),
            endDate: new Date(end),
            startTime: new Date(start),
            endTime: new Date(end),
            isUpdate: true,
        };
        const success = await createOrUpdateEvent(token, values);

        // if not successful, revert changes
        if (!success) setEventsList(eventsList);

        //const [responseStatus, data] = await changeEvent(token, event, start, end, event.allDay);
    }, [setEventsList]);

    // delete events
    const handleDelete = async () => {
        handleCloseEventDialog();

        const response = await deleteEvent(token, { 
            eventId: selectedEvent.id, 
            workspaceId: selectedEvent.workspaceId,
        });

        if (response) {
            setEventsList((prev) => prev?.filter((e) => e.id !== selectedEvent.id));
            // todo: show snackbar
        }
    };
    
    // create a material ui dialog to see the details of the event
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleCloseEventDialog = () => {
        setSelectedEvent(null);
        setOpenEventDialog(false);
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    }

    const action = (
        <React.Fragment>
            <Button color="primary" size="small" onClick={handleCloseSnackbar}>
                UNDO
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="primary"
                onClick={handleCloseSnackbar}
            >
                <CancelRounded fontSize="small" />
            </IconButton>
        </React.Fragment>
    )

    const [openEventDialog, setOpenEventDialog] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    
    // handle selecting an existing event
    const handleSelectEvent = (event) => {
        setSelectedEvent(event);
        setOpenEventDialog(true);
    };

    // editEventDialog
    const editEventInitialValues = useRef();

    const [ openEditDialog, setOpenEditDialog ] = useState(false);

    // handle selecting a slot to create a new event
    const handleSelectSlots = (value, defaultValues) => {
        const initialValues = {
            title: defaultValues?.title || "",
            workspaceId: defaultValues?.workspaceId || currentWorkspaces[0],
            attendees: defaultValues?.attendees || [],
            attachments: defaultValues?.attachments || [],
            description: defaultValues?.description || "",
            virtualConferenceType: defaultValues?.virtualConferenceType || "",
            link: defaultValues?.link || "",
            isUpdate: false,
        };

        if (value) {
            initialValues.startDate   = new Date(value.start);
            initialValues.endDate     = new Date(value.end);
            initialValues.startTime   = new Date(value.start);
            initialValues.endTime     = new Date(value.end);
            initialValues.allDay      = !isSameDay(value.start, value.end);
        }
        editEventInitialValues.current = initialValues;
        setOpenEditDialog(true);
    };

    const handleCloseEditDialog = (id) => {
        setOpenEditDialog(false);
        
        if (id === "save") {
            // open snackbar
        }
    };

    const handleSuccessEditEvent = (newEvent) => {
        // todo: close snackbar

        // remove old event from eventsList if it is an update
        const trimmedEventsList = newEvent.isUpdate ? eventsList?.filter((e) => e.id !== newEvent.prevEventId) : eventsList;
        setEventsList([...trimmedEventsList, newEvent]);
    };

    const handleEditEvent = () => {
        console.log(selectedEvent)
        const initialValues = {
            title: selectedEvent.title,
            workspaceId: selectedEvent.workspaceId,
            startDate: new Date(selectedEvent.start),
            endDate: new Date(selectedEvent.end),
            startTime: new Date(selectedEvent.start),
            endTime: new Date(selectedEvent.end),
            allDay: selectedEvent.allDay,
            attendees: selectedEvent.attendees || [],
            attachments: selectedEvent.attachments || [],
            description: selectedEvent.description,
            virtualConferenceType: selectedEvent.link?.includes("zoom") ? "zoom"
                : selectedEvent.link?.includes("google") ? "google_meet"
                : selectedEvent.link?.includes("microsoft") ? "microsoft_teams"
                : ""
                ,
            link: selectedEvent.link,
            // new parameters
            isUpdate: true,
            eventId: selectedEvent.id,
            prevWorkspaceId: selectedEvent.workspaceId,
        };
        editEventInitialValues.current = initialValues;
        handleCloseEventDialog();
        setOpenEditDialog(true);
    }

    return (
        <Box height="calc(100vh - 64px)">
            <DnDCalendar
                localizer={localizer}
                events={eventsList}

                //unused draggableAccessor={(event) => true} 
                eventPropGetter={eventStyleGetter}

                selectable
                onSelectEvent={handleSelectEvent}

                onEventDrop={moveEvent}
                onEventResize={moveEvent}

                // onKeyDown={(e) => handleKeyDown(e)}
                onSelectSlot={handleSelectSlots}

                // Custom Toolbar
                date={date}
                onNavigate={(date) => dispatch(setCalendarDate({ date: date.toString() }))}
                view={view}
                onView={(view) => dispatch(setCalendarView({ view }))}
                components={{
                    toolbar: () => <></>
                }} 
            />

            {openEventDialog && 
                <EventDialog 
                    open={openEventDialog}
                    event={selectedEvent} 
                    handleClose={handleCloseEventDialog}
                    handleEdit={handleEditEvent}
                    handleDelete={handleDelete}
                />
            }

            {openEditDialog && 
                <EditEventDialog 
                    open={openEditDialog} 
                    handleClose={handleCloseEditDialog}
                    handleSuccess={handleSuccessEditEvent}
                    initialValues={editEventInitialValues.current}
                />
            }
            <Snackbar 
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message="Meeting Successfully Edited!"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                action={action}
            />
        </Box>
    );
}

export default CalendarPage;